/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "Ụnyaahụ",
      "0": "Taa",
      "1": "Echi",
      "future": {
        "other": "+{0} d"
      },
      "past": {
        "other": "-{0} d"
      }
    },
    "day-narrow": {
      "-1": "Ụnyaahụ",
      "0": "Taata",
      "1": "Echi",
      "future": {
        "other": "n’ụbọchị {0}"
      },
      "past": {
        "other": "n’ụbọchị {0} gara aga"
      }
    },
    "day-short": {
      "-1": "Ụnyaahụ",
      "0": "Taata",
      "1": "Echi",
      "future": {
        "other": "n’ụbọchị {0}"
      },
      "past": {
        "other": "n’ụbọchị {0} gara aga"
      }
    },
    "hour": {
      "0": "elekere a",
      "future": {
        "other": "+{0} h"
      },
      "past": {
        "other": "-{0} h"
      }
    },
    "hour-narrow": {
      "0": "elekere a",
      "future": {
        "other": "+{0} h"
      },
      "past": {
        "other": "-{0} h"
      }
    },
    "hour-short": {
      "0": "elekere a",
      "future": {
        "other": "+{0} h"
      },
      "past": {
        "other": "-{0} h"
      }
    },
    "minute": {
      "0": "nkejị a",
      "future": {
        "other": "+{0} min"
      },
      "past": {
        "other": "-{0} min"
      }
    },
    "minute-narrow": {
      "0": "nkejị a",
      "future": {
        "other": "+{0} min"
      },
      "past": {
        "other": "-{0} min"
      }
    },
    "minute-short": {
      "0": "nkejị a",
      "future": {
        "other": "+{0} min"
      },
      "past": {
        "other": "-{0} min"
      }
    },
    "month": {
      "-1": "Ọnwa gara aga",
      "0": "Ọnwa a",
      "1": "Ọnwa na-abịa",
      "future": {
        "other": "+{0} m"
      },
      "past": {
        "other": "-{0} m"
      }
    },
    "month-narrow": {
      "-1": "Ọnwa gara aga",
      "0": "Ọnwa a",
      "1": "Ọnwa na-abịa",
      "future": {
        "other": "+{0} m"
      },
      "past": {
        "other": "-{0} m"
      }
    },
    "month-short": {
      "-1": "Ọnwa gara aga",
      "0": "Ọnwa a",
      "1": "Ọnwa na-abịa",
      "future": {
        "other": "+{0} m"
      },
      "past": {
        "other": "-{0} m"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "Nkejị keanọ gara aga",
      "0": "nkejị keanọ a",
      "1": "nkejị keanọ na abịa",
      "future": {
        "other": "Nkejị keanọ {0}"
      },
      "past": {
        "other": "Nkejị keanọ {0} gara aga"
      }
    },
    "quarter-narrow": {
      "-1": "Nkejị keanọ gara aga",
      "0": "nkejị keanọ a",
      "1": "nkejị keanọ na abịa",
      "future": {
        "other": "Nkejị keanọ {0}"
      },
      "past": {
        "other": "Nkejị keanọ {0} gara aga"
      }
    },
    "quarter-short": {
      "-1": "Nkejị keanọ gara aga",
      "0": "nkejị keanọ a",
      "1": "nkejị keanọ na abịa",
      "future": {
        "other": "Nkejị keanọ {0}"
      },
      "past": {
        "other": "Nkejị keanọ {0} gara aga"
      }
    },
    "second": {
      "0": "ụgbụa",
      "future": {
        "other": "+{0} s"
      },
      "past": {
        "other": "-{0} s"
      }
    },
    "second-narrow": {
      "0": "ụgbụa",
      "future": {
        "other": "+{0} s"
      },
      "past": {
        "other": "-{0} s"
      }
    },
    "second-short": {
      "0": "ụgbụa",
      "future": {
        "other": "+{0} s"
      },
      "past": {
        "other": "-{0} s"
      }
    },
    "week": {
      "-1": "Izu gara aga",
      "0": "Izu a",
      "1": "Izu na-esote",
      "future": {
        "other": "+{0} w"
      },
      "past": {
        "other": "-{0} w"
      }
    },
    "week-narrow": {
      "-1": "Izu gara aga",
      "0": "Izu a",
      "1": "Izu na-esote",
      "future": {
        "other": "+{0} w"
      },
      "past": {
        "other": "-{0} w"
      }
    },
    "week-short": {
      "-1": "Izu gara aga",
      "0": "Izu a",
      "1": "Izu na-esote",
      "future": {
        "other": "+{0} w"
      },
      "past": {
        "other": "-{0} w"
      }
    },
    "year": {
      "-1": "Afọ gara aga",
      "0": "Afọ a",
      "1": "Afọ na-abịa",
      "future": {
        "other": "+{0} y"
      },
      "past": {
        "other": "-{0} y"
      }
    },
    "year-narrow": {
      "-1": "Afọ gara aga",
      "0": "Afọ a",
      "1": "afọ na-abịa",
      "future": {
        "other": "+{0} y"
      },
      "past": {
        "other": "Afọ {0} gara aga"
      }
    },
    "year-short": {
      "-1": "Afọ gara aga",
      "0": "Afọ a",
      "1": "afọ na-abịa",
      "future": {
        "other": "+{0} y"
      },
      "past": {
        "other": "-{0} y"
      }
    }
  },
  "locale": "ig"
})
}
